exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolbar-user {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-flow: column nowrap;\r\n          flex-flow: column nowrap;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n}\r\n\r\n.toolbar-user__avatar {\r\n  display: block;\r\n  cursor: pointer;\r\n  width: 26px;\r\n  height: 26px;\r\n  margin: auto;\r\n}\r\n\r\n.toolbar-user__firstname {\r\n  font-size: 0.7rem;\r\n  text-align: center;\r\n  margin: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-user/toolbar-user.component.css
// module id = ../../../../../src/app/toolbar/toolbar-user/toolbar-user.component.css
// module chunks = 4